import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, ButtonRetry, LabelMessage } from './RetryOffers.styled';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';

function RetryOffers({ onRetry }) {
  const { globalization, targetedOffersLoading } =
    useContext(CruiseSearchContext);

  const { filtersDictionary } = globalization?.dictionaries || {};
  const {
    labelTargetedOffersProblemRetrievingYourOffers,
    actionTargetedOffersRetry,
  } = filtersDictionary;

  return (
    <Wrapper>
      <LabelMessage>
        {labelTargetedOffersProblemRetrievingYourOffers}
      </LabelMessage>
      <ButtonRetry secondary onClick={onRetry} disabled={targetedOffersLoading}>
        {actionTargetedOffersRetry}
      </ButtonRetry>
    </Wrapper>
  );
}

RetryOffers.propTypes = {
  onRetry: PropTypes.func,
};

RetryOffers.defaultProps = {};

export default RetryOffers;
